import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShowsApiService {
  readonly areasBaseUrl = '/api/v1.0/shows';
  constructor(private http: HttpClient) {}

  moveShow(showId: string, payload: MoveShowPayload): Observable<MoveShowResponse> {
    return this.http.post<MoveShowResponse>(`${this.areasBaseUrl}/${showId}/move`, payload);
  }
}

export interface MoveShowPayload {
  area_id: string;
  start: string; //iso date
  dry_run: boolean;
}
export interface MoveShowResponse {
  is_available: true;
  is_capacity_sufficient: true;
}
